import React from 'react';
import {
  Router,
  Route,
  Link,
  Switch
} from 'react-router-dom'

import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import ErrorHandler from './ErrorHandler';
import Home from './Home';
import createHistory from 'history/createBrowserHistory'
import unregister from './registerServiceWorker';
import ReactGA from 'react-ga';

ReactGA.initialize('UA-8530787-10');
const history = createHistory()
history.listen((location, action) => {
  ReactGA.set({ page: location.pathname });
  ReactGA.pageview(location.pathname);
  console.log(location.pathname)
});

const Routes = () => (
  <Router history={history}>
    <div>
      <Switch>
        <Route path="/" exact  render={(props) => <Home {...props} />}/>
        <Route path="/browser/:character([a-z0-9]{3})/:mot?" render={(props) => <App {...props} routeInfo={props.match} />}/>
        <Route path="/:character([a-z0-9]{3})/:mot?"  render={(props) => <App {...props} routeInfo={props.match} />}/>
        <Route component={ErrorHandler} />
      </Switch>
    </div>
  </Router>
)
ReactDOM.render(Routes(), document.getElementById('root'));
unregister();



// WEBPACK FOOTER //
// ./src/index.js